import * as api from '@api';
import LoginMap from '@components/map';
import {
  Flex,
  Heading,
  Preloader,
  Text,
} from '@retracedgmbh/ui-components-lib';
import { useAuth } from '@state/auth';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

const SingleSignOnCallback = () => {
  const [searchParams] = useSearchParams();
  const [isFailure, setIsFailure] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const login = useAuth(state => state.login);
  const hasExchanged = React.useRef(false);

  useEffect(() => {
    const error = searchParams.get('error');

    if (error) {
      setIsLoading(false);
      setIsFailure(true);
      return;
    }

    if (hasExchanged.current) return;
    hasExchanged.current = true;

    const ssoCode = searchParams.get('sso_code');
    if (!ssoCode) return;

    api.backend
      .exchangeSsoCode(ssoCode)
      .then(response => {
        setIsLoading(false);
        if (response.status < 400) {
          login(response.data);
          navigate('/', { replace: true });
        } else {
          setIsFailure(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
        setIsFailure(true);
      });
  }, [searchParams]);

  return (
    <section className='hero is-fullheight login-page'>
      <div className='retraced-light-logo'>
        <img
          src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/secondary-logo-cloud-v2.svg`}
          alt='retraced with text'
          width='150'
          loading='lazy'
        />
        <Heading as='h2'>
          Next generation supply chain transparency. At your finger tips.
        </Heading>
      </div>
      <div className='hero-body' style={{ padding: '0px' }}>
        <div
          className='columns is-centered'
          style={{ width: '100%', margin: 0, padding: 10 }}
        >
          <div className='column is-half-tablet is-three-fifths-hd is-centered '>
            <img
              src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/secondary-logo-black-v2.svg`}
              className='tw:mb-5 is-hidden-tablet'
              style={{ margin: 'auto' }}
              alt='retraced with text'
              width='150'
              loading='lazy'
            />
          </div>
          <div
            className='column is-centered login-container tw:bg-primary-light '
            style={{ minHeight: 400 }}
          >
            {!isLoading && isFailure && (
              <div className='notification is-danger tw:text-center'>
                your are not register, please contact us.
                <br />
                <Link
                  to='https://status.retraced.com'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Text as='span'>Check the status page</Text>
                </Link>
              </div>
            )}
            {isLoading && (
              <Flex alignItems='center' justify='center' className='tw:h-full'>
                <Preloader loadingText='Signing you...' />
              </Flex>
            )}
          </div>
        </div>
      </div>

      <div id='background_image'>
        <LoginMap />
        <img
          alt='Traceability Map'
          id='image0_202_138'
          width='100%'
          height='1734'
          src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/map.svg`}
        />
      </div>
    </section>
  );
};

export default SingleSignOnCallback;
